export const formatCurrency = (value: number | undefined | null, currency?: string, lang: string = 'pt'): string => {
  const code = (currency || 'EUR').toUpperCase();
  try {
    return new Intl.NumberFormat(lang === 'pt' ? 'pt-PT' : 'en-IE', { style: 'currency', currency: code }).format(Number(value ?? 0));
  } catch {
    return `${Number(value ?? 0).toFixed(2)} ${code}`;
  }
};

export const formatNumber = (
  value: number | undefined | null,
  lang: string = 'pt',
  options?: Intl.NumberFormatOptions
): string => {
  try {
    return new Intl.NumberFormat(lang === 'pt' ? 'pt-PT' : 'en-IE', options).format(Number(value ?? 0));
  } catch {
    return String(Number(value ?? 0));
  }
};

export const formatDate = (date: string | undefined | null, lang: string = 'pt'): string => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString(lang === 'pt' ? 'pt-PT' : 'en-IE');
};

export const formatDateTime = (date: string | undefined | null, lang: string = 'pt'): string => {
  if (!date) return '-';
  return new Date(date).toLocaleString(lang === 'pt' ? 'pt-PT' : 'en-IE');
};
